import LogoSvg from "../../assets/svg/logo.svg";
import LogoDark from "../../assets/svg/logo_dark.svg";
import { ExtensionNudge } from "./ExtensionNudge";

interface HeroAction {
  id: number;
  label: string;
  Icon: string;
}

interface HeroActionsProps {
  userName: string;
  actions: HeroAction[];
  onActionClick: (label: string) => void;
  disabled?: boolean;
}

export function HeroActions({
  userName,
  actions,
  onActionClick,
  disabled = false,
}: HeroActionsProps) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col items-center gap-8 px-4">
        <div className="flex flex-col items-center gap-4">
          <div className="h-16 w-16 overflow-hidden rounded-full">
            <img
              src={LogoSvg}
              alt="Dune Works"
              className="h-full w-full object-cover dark:hidden"
            />
            <img
              src={LogoDark}
              alt="Dune Works"
              className="h-full w-full object-cover hidden dark:block"
            />
          </div>
          <div className="text-center">
            <h1
              className="text-[32px] font-semibold text-[#1D1B19] dark:text-[#E3E6EA]"
              style={{ fontFamily: "Sofia Pro, sans-serif", fontWeight: 600 }}
            >
              Hello, {userName}!
            </h1>
            <p
              className="mt-1 text-base text-[#8E8378] dark:text-[#9AAABF]"
              style={{ fontFamily: "Sofia Pro, sans-serif", fontWeight: 300 }}
            >
              Get started with Dune Works:
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {actions.map((action) => (
            <button
              key={action.id}
              type="button"
              onClick={() => !disabled && onActionClick(action.label)}
              disabled={disabled}
              className="group flex items-center gap-2 rounded-xl border border-[#D3C8BB] dark:border-[#455D7D] bg-[#F3ECE4] dark:bg-[#2C405F] px-3 py-2.5 text-left shadow-sm transition hover:border-[#D3C8BB] dark:hover:border-[#6E829E] hover:bg-[#efe6dc] dark:hover:bg-[#455D7D] hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50"
            >
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-transparent">
                <img
                  src={action.Icon}
                  alt={action.label}
                  className="h-4 w-4 dark:[filter:brightness(0)_saturate(100%)_invert(98%)_sepia(2%)_saturate(1086%)_hue-rotate(185deg)_brightness(98%)_contrast(93%)]"
                />
              </div>
              <span
                className="text-[13.2px] font-normal text-[#4A4744] dark:text-[#F3F4F6]"
                style={{ fontFamily: "Sofia Pro, sans-serif", fontWeight: 400 }}
              >
                {action.label}
              </span>
            </button>
          ))}
        </div>

        {/* Chrome Extension Nudge Banner */}
        <ExtensionNudge />
      </div>
    </div>
  );
}
